export default "__VITE_ASSET__BLlbetjV__"